export const environment = {
  apiGet: 'https://webbis.compragamer.com/serpir',
  apiStatic: 'https://static.compragamer.com/',
  apiImageStatic: 'https://imagenes.compragamer.com',
  apiClient: '/sercli',
  apiGetNet: 'https://serviciosweb.compragamer.com/net_micro_web2/',
  imagenes_aplicaciones: 'https://imagenes.compragamer.com/aplicaciones/',
  svgIcons: './assets/icons/',
  assetsImage: './assets/img/',
  assets: './assets/',
  googleAnalytics: 'UA-85902112-1',
  noCaptcha: false,
  production: true,
  env: 'produccion',
  img: 'https://imagenes.compragamer.com/productos/compragamer_Imganen_general_',
  sdk_face: 'https://connect.facebook.net/en_US/sdk.js',
  //Facebook PROD
  appId_face: '372290459823787',
  //appId_face: '2658743117688878',
  sdk_google: 'https://apis.google.com/js/platform.js?onload=googleSDKLoaded',
  clientId_google: '93421155667-boh26mbr1nfbnnov92s4ujshr8t13ljk.apps.googleusercontent.com',
  imgs_marcas: 'https://imagenes.compragamer.com/marcas/',
  //recaptcha PROD
  recaptcha_site: '6LcJOdkZAAAAACPpU8GyqN3jPxV1VDhJHsbuWgHV',
  routerDirect: true,
  endpoint: '/serviciosAnx/pago',
  experimentalDev: false,
  apiCG: 'https://preproduccion.api.compragamer.com/',
  useServiceWorkers: true,
  base_CG_URL: 'https://preproduccion.compragamer.com/',
  getnetCheckout: 'https://www.globalgetnet.com/digital-checkout/loader.js',
  HARDCODE_GETNET: true,
  localDev: false,
};
